import {memo, useCallback, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {DatePickerV2} from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {
  FINANCIAL_DOC_STATUS,
  FINANCIAL_DOC_TYPE,
  SECTOR_OPTIONS,
  SKBDN_TYPES,
} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {financialDocsSelector, setFilter} from '../../../redux/slices/financialDocsSlices'
import {TRowFilter} from '../../../components/Table/Table'
import { useFindocOption } from 'src/hooks/useFindocOption'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {salesOrgOptions} = useSalesOrganization()
  const {findocTypesOption} = useFindocOption()
  const {filter} = useAppSelector(financialDocsSelector)
  const dispatch = useAppDispatch()

  const handleChange = useCallback(
    (value: Partial<typeof filter>) => {
      dispatch(setFilter({...filter, ...value}))
    },
    [dispatch, filter]
  )

  useEffect(() => {
    let _filter = filter
    try{
      let storage = localStorage.getItem('redux-findoc-filter') as string
      if(storage){
        let persisted = JSON.parse(storage)
        _filter = {
          ...filter,
          ...persisted
        }
        dispatch(setFilter(_filter))
      }
    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Findoc Number')}
          value={filter?.findoc_number ?? ''}
          onChange={({target}) => handleChange({findoc_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pembeli')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('SAP Number')}
          value={filter?.sap_number ?? ''}
          onChange={({target}) => handleChange({sap_number: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('kontrak-tanggal')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleChange({created_at: startDate})}
        />
      </td>
      <td className='td-order-4 text-center pm-0'>
        <Selection
          placeholder={t('Sales Org')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleChange({sales_org_code})}
        />
      </td>
      <td className='td-order-3 text-center pm-0'>
        <Selection
          placeholder={t('sub-order-sektor')}
          data={SECTOR_OPTIONS}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => handleChange({sector_id})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Tanggal Findoc')}
          isSelectsRange={false}
          startDate={filter?.tgl_findoc ?? ''}
          onChange={({startDate}) => handleChange({tgl_findoc: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Ext Findoc Number')}
          value={filter?.num_findoc}
          onChange={({target}) => handleChange({num_findoc: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Findoc Type')}
          data={findocTypesOption}
          value={filter?.findoc_type ?? ''}
          onChange={(value: any) => handleChange({findoc_type: value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Skbdn Type')}
          data={SKBDN_TYPES}
          value={filter?.type_skbdn ?? ''}
          onChange={(type_skbdn) => handleChange({type_skbdn})}
        />
      </td>
      <td className='td-order-4 text-center pm-0'>
        <TextInputV2
          placeholder={t('no skkp/lecto')}
          value={filter?.no_skpp}
          onChange={({target}) => handleChange({no_skpp: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sub-order-negara')}
          value={filter?.negara_desc ?? ''}
          onChange={({target}) => handleChange({negara_desc: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('mataUang')}
          value={filter?.currency ?? ''}
          onChange={({target}) => handleChange({currency: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Bank')}
          value={filter?.bank_name ?? ''}
          onChange={({target}) => handleChange({bank_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Findoc Value')}
          value={filter?.nilai ?? ''}
          onChange={({target}) => handleChange({nilai: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('uangSaku')}
          value={filter?.allowance ?? ''}
          onChange={({target}) => handleChange({allowance: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sisafindoc')}
          value={filter?.resedual_value ?? ''}
          onChange={({target}) => handleChange({resedual_value: target.value})}
        />
      </td>
      <td className='td-order-3 text-center pm-0'>
        <TextInputV2
          placeholder={t('TOP')}
          value={filter?.top ?? ''}
          onChange={({target}) => handleChange({top: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Incoterm')}
          value={filter?.incoterm}
          onChange={({target}) => handleChange({incoterm: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Valid Start Date')}
          isSelectsRange={false}
          startDate={filter?.validity_date_from ?? ''}
          onChange={({startDate}) => handleChange({validity_date_from: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('valid End Date')}
          isSelectsRange={false}
          startDate={filter?.validity_date_to ?? ''}
          onChange={({startDate}) => handleChange({validity_date_to: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Latest Shipment Date')}
          isSelectsRange={false}
          startDate={filter?.delivery_deadline ?? ''}
          onChange={({startDate}) => handleChange({delivery_deadline: startDate})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Status')}
          data={FINANCIAL_DOC_STATUS}
          value={filter?.status ?? ''}
          onChange={(status) => handleChange({status})}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
}

export default memo(RowFilter)
